module.exports = __webpack_public_path__ + "images/noavatar-3e6075.png";